import Vue from 'vue';
import BaiduMapNew from '~/components/BaiduMapNew/index';

const AK = "eq9qyXSMGH99WEQxxE8MzSF7IpmE7mcP";
Vue.use(BaiduMapNew, {
    load: {
        ak: AK
    }
});